import React from 'react';
import { inject, observer } from 'mobx-react';

@inject('portalLoginStore')
@observer
class MultiLang extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const { portalLoginStore, isSetting, getState } = this.props;
        let { multiLangs, state, setState } = portalLoginStore;
        state = getState();
        const { langId, langText, hasMultiLang, multiLangVisible } = state;

        if (!hasMultiLang) {
            return <div className="simplelogin-multiLang" />;
        }

        let selectedClassName = '';
        let multiLangListComp = '';
        if (multiLangVisible) {
            selectedClassName = 'simplelogin-multiLangText-selected';
            multiLangListComp = (
                <div className="simplelogin-multiLangList">
                    <ul>
                        {
                            multiLangs.map(item => (
                                    <li
                                      className={`simplelogin-multiLangList-item ${item.id == langId ? 'simplelogin-multiLangList-selected' : ''}`}
                                      onClick={() => {
                                            portalLoginStore.getLoginForm({ langId: item.id });
                                            portalLoginStore.setState({ langId: item.id, langText: item.language, multiLangVisible: false });
                                        }}
                                    >
                                        {item.language}
                                    </li>
                                ))
                        }
                    </ul>
                </div>
            );
        }

        return (
            <div className="simplelogin-multiLang">
                <div
                  className={`simplelogin-multiLangText ${selectedClassName}`}
                  onClick={(e) => {
                        if (!isSetting) {
                            e.preventDefault && e.preventDefault();
                            e.stopPropagation && e.stopPropagation();
                            setState({ multiLangVisible: !multiLangVisible });
                        }
                    }}
                >
                    <div className="simplelogin-multiLangText-text">{langText}</div>
                    <div className="simplelogin-multiLangText-icon">▼</div>
                </div>
                {multiLangListComp}
            </div>
        );
    }

    onMultiLangChange = () => {

    }
}

export default MultiLang;



// WEBPACK FOOTER //
// ../src4js/pc4mobx/portal4theme/components/login/simpleLogin/formCloud/multiLang.js